import { Grid, Typography } from "@mui/material";
import React from "react";
import {
  CmpStatusIcon,
  CmpTypographyField,
} from "../../../Component/Common/ToolBox/ToolBox";
import moment from "moment";
import { useNavigate } from "react-router-dom";

const EasyBinTransferSummaryCard = ({ data = [], onClick }) => {
  return (
    <Grid container spacing={1} className="easy-putaway-container mt-1">
      
      {data.map((item, index) => (
        <Grid
          item
          xs={12}
          sm={6}
          md={6}
          key={index}
          onClick={() => {
            onClick(item);
          }}
        >
          <div className="easy-putaway-card">
            <Grid container spacing={0.5} columns={{ xs: 12, md: 12 }}>
              <Grid item xs={6} md={3}>
                <Typography variant="subtitle1" className="label">
                Trans #
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="body1" className="value">
                  {item?.DocNo}
                  {/* {item?.RefNo} */}
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="subtitle1" className="label">
                  Date
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="body1" className="value">
                  {moment(item?.Date).format("MM/DD/YYYY")}
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="subtitle1" className="label">
                Type
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="body1" className="value">
                  {/* {item?.A_VocNo} */}
                  {item?.Type}
                </Typography>
              </Grid>          

              <Grid item xs={6} md={3}>
                <Typography variant="subtitle1" className="label">
                  Status
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="body1" className="value">
                  {/* {item?.Status} */}
                  <CmpStatusIcon xStatus={item?.Status} />
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="subtitle1" className="label">
                CardId
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="body1" className="value">
                  {item?.CardId}
                </Typography>
              </Grid>
  
            </Grid>
          </div>
        </Grid>
      ))}
    </Grid>
  );
};

export default EasyBinTransferSummaryCard;
